import MDBox from "components/MDBox";
import { ETypeContent } from "../content.type";
import ContentUpdateHousing from "./content-update-housing";

function SectionFaq(): JSX.Element {
  return (
    <MDBox>
      <ContentUpdateHousing
        title="FAQ section 1"
        typeContent={ETypeContent.faq1}
      />
      <ContentUpdateHousing
        title="FAQ section 2"
        typeContent={ETypeContent.faq2}
      />
      <ContentUpdateHousing
        title="FAQ section 3"
        typeContent={ETypeContent.faq3}
      />
      <ContentUpdateHousing
        title="FAQ section 4"
        typeContent={ETypeContent.faq4}
      />
    </MDBox>
  );
}

export default SectionFaq;
